<template>
  <autocomplete-single name="Категория пользователя" :items="state.data.items" :select.sync="localSelect" :loading="state.loading"/>
</template>

<script>

import AutocompleteSingle from "@/componentsV2/base/AutocompleteSingle.vue";
import {Entity_ComUserCat} from "../../../EntityStoreCacheService";
import Stater from "@/plugins/stater";

export default {
  components: {AutocompleteSingle},
  props:[
    'select',
  ],
  data:()=>({
    state: new Stater({items:[],count:0}),
    arr: [],
    localSelect: null
  }),
  watch: {
    select() {
      this.localSelect = this.select;
    },
    localSelect() {
      this.$emit('update:select', this.localSelect)
    }
  },
  mounted() {
    this.localSelect = this.select;
    new Entity_ComUserCat()
        .selects(Entity_ComUserCat.id)
        .selects(Entity_ComUserCat.name)
        .order(Entity_ComUserCat.name, true)
        .addStateCallback(v=> this.state.setRequestBuilderState(v))
        .request()
  },
}
</script>